import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/bigDriveway/blog-driveway-size-001.jpg";
import img002 from "../../images/bigDriveway/blog-driveway-size-002.jpg";
import img003 from "../../images/bigDriveway/blog-driveway-size-003.jpg";
import img004 from "../../images/bigDriveway/blog-driveway-size-004.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const BigDrivewayData = {
  title:
    "How Big Should a Driveway Be? Sizing Considerations for Your Los Angeles Home",
  image: img001,
  destination: "/blog/big-driveway-sizing-considerations-los-angeles-home",
  date: "September 22, 2016",
  categories: ["blog", "driveways", "paving-stones", "permeable-pavers"],
};

const BigDriveway = () => {
  const blog = [BigDrivewayData];

  return (
    <>
      <SEO
        title="How Wide & Long Should a Driveway Be in Los Angeles?"
        description="Driveway sizes in Los Angeles varies based on a variety of factors, but there are some general guidelines to follow when determining how big a driveway needs to be."
        profileURL={
          "https://www.pacificpavingstone.com/blog/big-driveway-sizing-considerations-los-angeles-home"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/big-driveway-sizing-considerations-los-angeles-home",
          headline: "How Wide & Long Should a Driveway Be in Los Angeles?",
          description:
            "Driveway sizes in Los Angeles varies based on a variety of factors, but there are some general guidelines to follow when determining how big a driveway needs to be.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-driveway-size-001.14cc00a7.jpg",
          },
          datePublished: "2016-09-22",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Whether you realize it or not, driveways make a big first
              impression. They’re one of the first things someone sees as they
              approach your home, and the design, shape and size of your
              driveway are incredibly important.
              <br />
              <br />
              Too often, homeowners underestimate the importance of a
              well-planned driveway, and they end up with a driveway that’s
              undersized and frustrating to use.
              <br />
              <br />
              Driveway sizes in Los Angeles varies based on a variety of
              factors, but there are some general guidelines to follow when
              determining how big a driveway needs to be.
            </p>
            <h4>Standard Driveway Lengths and Widths</h4>
            <img src={img002} alt="Feature" />
            <p>
              As a general rule, your driveway should be a minimum of 18 to 20
              feet long. Allow 22 to 24 feet for full-sized pickups and
              oversized minivans. Plan your driveway with a minimum width of 10
              to 12 feet per vehicle. If space allows, make the driveway even
              wider to allow more space to walk between vehicles. A two-car
              driveway where the cars are parked next to each other should be at
              least 18 to 20 feet wide.
              <br />
              <br />
              These sizing guidelines are just the minimum, and there are many
              different factors to take into consideration when determining how
              big a driveway should be.
            </p>
            <h4>Sizing Considerations for Your Driveway</h4>
            <p>
              When determining the length and width of your driveway, the
              standard sizing guidelines are a good place to start. However,
              there are additional factors that should be taken into
              consideration including:
            </p>
            <h4>City Codes or Local Ordinances</h4>
            <p>
              Before starting construction on a driveway, always check city
              codes and local ordinances regarding driveway construction
              guidelines. Also, if you live in a neighborhood with a homeowner’s
              association, check to see if they have any restrictions regarding
              styles or sizing for driveways before getting too far into your
              plans.
            </p>
            <h4>Number of Vehicles in Household</h4>
            <p>
              The number of vehicles in your household is one of the biggest
              factors that determines the size of your driveway. The more
              vehicles you have, the longer and wider your driveway will need to
              be. Additionally, if you frequently entertain guests at your home,
              you’ll need extra spaces for those guests to park.
              <br />
              <br />
              If space allows, you’ll want to add extra room so people can
              easily walk between vehicles, open doors, ride bikes down the
              driveway, etc.
            </p>

            <h4>Other Uses for Your Driveway</h4>
            <img src={img003} alt="Feature" />
            <p>
              Will your driveway also serve as a place for your kids to play
              basketball or ride their bike? Are you planning on parking a
              motorhome or large boat on your driveway? These are just some of
              the important questions to consider when determining the size of
              your driveway.
            </p>
            <h4>Hiring a Professional Paving Company in Los Angeles</h4>
            <p>
              There are many different factors to consider when determining the
              size of a paving stone driveway. Your best option is to hire a
              professional paving contractor who can help you determine the
              right size and layout of your driveway.
            </p>
            <p>
              When hiring a professional, here are some qualifications to look
              for:
            </p>
            <ul>
              <li>In-house designer and installers</li>
              <li>Good online reputation</li>
              <li>Plenty of local references</li>
              <li>
                Longstanding track record for quality work and great service
              </li>
              <li>Detailed written estimate with timeline for work</li>
              <li>No shady incentives or high-pressure tactics</li>
              <li>
                Licenses, credentials, and proof of insurances in their
                company’s name
              </li>
              <li>
                Understanding of which pavers are best to use on driveways
              </li>
            </ul>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img004} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p className="text-blue"></p>
                <p>
                  At Pacific Pavingstone, we’ve completed tens of thousands of
                  paving stone driveways in Los Angeles and other areas of
                  Southern California. We’d love to help you with your next
                  project. We can help determine how big a driveway should be
                  and answer any questions you have about the process.
                  <br />
                  <br />
                  <Link to="/contact-us">
                    Contact us today to learn more about how Pacific Pavingstone
                    can help you transform your Southern California property.
                  </Link>
                </p>
              </div>
            </div>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(BigDriveway);
